var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 32,
    fill: "url(#paint0_linear_337_549)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.348 29.42C94.428 34.737 78 55.548 78 78C78 104.989 101.011 128 128 128C154.989 128 178 104.989 178 78C178 50.61 154.659 27.675 127.201 28.085C124.065 28.132 119.182 28.732 116.348 29.42ZM141.437 51.425C151.896 56.543 157.459 65.769 157.459 78C157.459 90.335 151.909 99.442 141.182 104.71C136.497 107.01 134.184 107.5 128 107.5C121.816 107.5 119.503 107.01 114.818 104.71C98.792 96.84 93.314 76.934 102.98 61.693C110.958 49.113 127.619 44.665 141.437 51.425ZM96.348 149.42C78.199 153.822 62.904 169.584 59.105 187.799C57.448 195.748 57.664 219.449 59.425 222.855C61.896 227.634 67.7219 229.229 72.9089 226.547C77.0519 224.405 77.878 221.042 78.205 205C78.48 191.467 78.686 190.121 81.29 184.818C84.451 178.381 89.296 173.684 95.949 170.606C100.227 168.626 102.148 168.5 128 168.5H155.5L161.182 171.29C167.631 174.457 172.334 179.315 175.374 185.949C177.119 189.757 177.511 192.866 177.775 205C178.124 221.051 178.952 224.407 183.091 226.547C188.278 229.229 194.104 227.634 196.575 222.855C198.336 219.449 198.552 195.748 196.895 187.799C192.987 169.059 176.941 153.013 158.201 149.105C150.763 147.554 103.039 147.797 96.348 149.42Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_549",
    x1: 0,
    y1: 0,
    x2: 301.5,
    y2: 76.3692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5FAB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c4e6f85ba77eb2c85809bf0042000fa2.svg";
export { ForwardRef as ReactComponent };